import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export interface MobileMenuLink {
  to: string;
  label: string;
}

export const PARTNER_LINKS: MobileMenuLink[] = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/analytics', label: 'Analitică' },
  { to: '/referrals', label: 'Referral-uri' },
  { to: '/invoices', label: 'Facturi' },
  { to: '/reports', label: 'Rapoarte' },
  { to: '/my-link', label: 'Link-ul Meu' },
  { to: '/profile', label: 'Profil' },
  { to: '/export', label: 'Export GDPR' },
];

export const ADMIN_LINKS: MobileMenuLink[] = [
  { to: '/admin/dashboard', label: 'Dashboard' },
  { to: '/admin/partners', label: 'Parteneri' },
  { to: '/admin/referrals', label: 'Referral-uri' },
  { to: '/admin/workflow', label: 'Workflow' },
  { to: '/admin/approvals', label: 'Aprobări' },
  { to: '/admin/audit-logs', label: 'Audit Logs' },
  { to: '/admin/settings', label: 'Setări' },
];

interface MobileMenuProps {
  links: MobileMenuLink[];
  onLogout?: () => void;
}

export function MobileMenu({ links, onLogout }: MobileMenuProps) {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <>
      <button
        type="button"
        aria-label="Meniu"
        aria-expanded={open}
        onClick={() => setOpen(true)}
        className="md:hidden -ml-2 p-2 text-ink"
      >
        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {open && (
        <div className="md:hidden fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setOpen(false)}
            aria-hidden="true"
          />
          <div className="absolute right-0 top-0 h-full w-72 max-w-[85vw] bg-white shadow-xl flex flex-col">
            <div className="flex items-center justify-between border-b border-border px-4 py-4">
              <span className="font-serif text-lg text-teal">Meniu</span>
              <button
                type="button"
                aria-label="Închide meniul"
                onClick={() => setOpen(false)}
                className="-mr-2 p-2 text-muted hover:text-ink"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <nav className="flex-1 overflow-y-auto px-2 py-2">
              {links.map(({ to, label }) => {
                const active = pathname === to;
                return (
                  <Link
                    key={to}
                    to={to}
                    className={`block rounded-lg px-3 py-3 text-base ${
                      active
                        ? 'bg-warm text-teal font-medium'
                        : 'text-ink hover:bg-warm/50'
                    }`}
                  >
                    {label}
                  </Link>
                );
              })}
            </nav>

            {onLogout && (
              <div className="border-t border-border px-2 py-2">
                <button
                  type="button"
                  onClick={onLogout}
                  className="block w-full rounded-lg px-3 py-3 text-left text-base text-muted hover:bg-warm/50 hover:text-ink"
                >
                  Deconectare
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
